import { render, staticRenderFns } from "./LabelWithHint.vue?vue&type=template&id=47d0ac2f&lang=pug"
import script from "./LabelWithHint.vue?vue&type=script&lang=ts"
export * from "./LabelWithHint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports